import { render, staticRenderFns } from "./CarouselPicturesEdit.vue?vue&type=template&id=48e11425&scoped=true&"
import script from "./CarouselPicturesEdit.vue?vue&type=script&lang=js&"
export * from "./CarouselPicturesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e11425",
  null
  
)

export default component.exports